<template>
  <div class="comp-login">
    <div class="login-form">
      <h1 class="login-form__title">線上教具系統</h1>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="rules"
        label-position="top"
        @keyup.enter.native="onSubmit">
        <el-form-item label="帳號" prop="email">
          <el-input v-model="loginForm.email" placeholder="請輸入帳號"/>
        </el-form-item>
        <el-form-item label="使用序號" prop="password">
          <el-input v-model="loginForm.password" placeholder="請輸入序號" />
        </el-form-item>
        <el-button
          class="login-form__login-btn u-width--full"
          type="primary"
          :disabled="disableLoginBtn"
          @click="onSubmit">登入
        </el-button>
        <p class="login-form__hint">
          <svg-icon class="login-form__hint-icon" name="circle-solid-info" />如忘記使用序號，請至信箱查看或與客服聯絡
        </p>
      </el-form>
    </div>
  </div>
</template>

<script>
import authApi from '@/api/auth'
import store from '@/store'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: '此為必填欄位', trigger: 'blur' },
          { type: 'email', message: '電子信箱格式錯誤', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '此為必填欄位', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    disableLoginBtn () {
      return !(this.loginForm.email && this.loginForm.password)
    }
  },
  beforeRouteEnter (to, from, next) {
    store.getters.isLogin
      ? next({ name: 'tool' })
      : next()
  },
  methods: {
    onSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) { return }

        authApi.login({
          email: this.loginForm.email,
          password: this.loginForm.password
        })
          .then(resp => {
            this.$store.commit('setUser', resp)
            this.$store.commit('setToken', resp.api_token)
            this.$router.push({ name: 'tool' })
          })
          .catch(err => {
            err.message === 'Forbidden'
              ? this.$errorMsg('帳號或使用序號錯誤')
              : this.$errorMsg(err.message)
          })
      })
    }
  }
}
</script>
